export default __webpack_public_path__ + "static/media/2.4b948947.png";